import {
    Box,
    Tab,
    Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    getRewardSettings
} from "../api/bot.api";
import { RootState } from "../store";
import { setRewardSettingsAction, setSelectedMenuAction } from "../store/slice";
import RewardHistoryTable from "./RewardHistoryTable";
import RewardSettings from "./RewardSettings";
import {
    MenuInterface
} from "./types";
import { TabContext, TabList, TabPanel } from "@mui/lab";

export default function RewardContainer() {
    const [tabValue, setTabValue] = useState<string>("1");
    const profile = useSelector((state: RootState) => state.profile);
    const dispatch = useDispatch();

    const getRewardSettingsHandler = async () => {
        const response = await getRewardSettings();
        if (response.success) {
            dispatch(setRewardSettingsAction(response.data));
        }
    };

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabValue(newValue);
    };

    useEffect(() => {
        dispatch(setSelectedMenuAction(MenuInterface.REWARD));
        getRewardSettingsHandler();
        const intervalId = setInterval(() => {
            getRewardSettingsHandler();
        }, 20000);
        return () => clearInterval(intervalId);
    }, []);

    return (
        <Box
            sx={{width: "100%", flex: 1, display: "flex", flexDirection: "row", maxHeight: "calc(100vh - 90px)", minHeight: "calc(100vh - 90px)",overflow: "hidden"}}>
            {profile.isAdmin && (
                <>
                    <Box sx={{flex: 1, flexDirection: 'column', display: {md: 'none', xs: 'flex'}}}>
                        <TabContext value={tabValue}>
                                <Box 
                                    sx={{bgcolor: 'background.paper',
                                        width: {sm: 500, xs: '90%'},
                                        marginX: 'auto',
                                        pt: 2,
                                        pb: 2,
                                        borderBottomRightRadius: 10,
                                        borderBottomLeftRadius: 10,
                                        display: 'flex',
                                        justifyContent: 'center',
                                    }}
                                >
                                <TabList onChange={handleTabChange} aria-label="lab API tabs example"
                                    sx={{
                                        '& .MuiTab-root': {
                                            bgcolor: 'background.default',
                                            margin: '0 4px',
                                            borderRadius: '4px 4px 0 0',
                                            '&.Mui-selected': {
                                                bgcolor: 'primary.main',
                                                color: 'primary.contrastText'
                                            }
                                        }
                                    }}>
                                    <Tab label="Reward Settings" value="1" sx={{px: {sm: 4, xs: 2}, fontSize: {sm: 16, xs: 14}}} />
                                    <Tab label="Reward History" value="2" sx={{px: {sm: 4, xs: 2}, fontSize: {sm: 16, xs: 14}}}/>
                                </TabList>
                                </Box>
                                <TabPanel value="1" sx={{overflowY: 'auto'}}>
                                    <RewardSettings getRewardSettingsHandler={getRewardSettingsHandler}/>
                                </TabPanel>
                                <TabPanel value="2" sx={{overflowY: 'auto'}}>
                                    <RewardHistoryTable/>
                                </TabPanel>
                        </TabContext>
                    </Box>
                    <Box sx={{flex: 1, display: {md: 'flex', xs: 'none'}, flexDirection: 'row'}}>
                        <RewardSettings getRewardSettingsHandler={getRewardSettingsHandler}/>
                        <Box sx={{flex: 1, display: 'flex', flexDirection: 'column', px: {md: 2, xs: 0}, pt: 3}}>
                            <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
                                Reward2 History
                            </Typography>
                            <RewardHistoryTable/>
                        </Box>
                    </Box>
                </>
            )}

            {!profile.isAdmin && (
                <Box display="flex" justifyContent="center" alignItems="center" sx={{ width: "100%", height: "100%", mt: 6 }}>
                    <Typography variant="h6" color="warning">
                        You are not authorized to access this page
                    </Typography>
                </Box>
            )}
        </Box>
    );
}
